module.exports = __webpack_public_path__ + "img/32.96150749.jpg";